import {setCookie} from "./components/Cookies";
import {MiniCartInit} from "./components/mini-cart";
import {activateDeferredLinks} from "./components/deferred-links";
import {ProductDescriptionCollapseInit} from "./components/product-description-collapse";
import {ProductFaqCollapseInit} from "./components/product-faq-collapse";
import {ConsentsCollapseInit} from "./components/consents";

MiniCartInit();

document.addEventListener('DOMContentLoaded',function() {

    ProductDescriptionCollapseInit();
    activateDeferredLinks();
    ProductFaqCollapseInit();
    ConsentsCollapseInit();

    const commentForm = document.getElementById('commentform');
    const loadMoreTags = document.getElementsByClassName('tags__button')[0]; 
    const tagsWrapper  = document.getElementsByClassName('tags__wrapper')[0];
    const tags  = document.getElementsByClassName('tags')[0];
    const cookieWrapper = document.querySelector('.exit-popup');
    const popupForm = document.querySelector('.exit-popup form');
    const navbarMain = document.getElementsByClassName('inst-navbar-main')[0];

    window.addEventListener("resize", detectVisibilityLoadMoreTags);

    function detectVisibilityLoadMoreTags() {
        const twoRowsHeight = 60;
        if (loadMoreTags && tagsWrapper)
            if (tagsWrapper.clientHeight > twoRowsHeight) {
                loadMoreTags.style.display = 'inline-block'
            } else {
                loadMoreTags.style.display = 'none'
            }
    }

    detectVisibilityLoadMoreTags();

    function padZero(num) {
        return num < 10 ? '0' + num : num;
    }
    
    function getFormattedDate() {
        let now = new Date();
        return `${padZero(now.getDate())}.${padZero(now.getMonth() + 1)}.${now.getFullYear()} ${padZero(now.getHours())}:${padZero(now.getMinutes())}:${padZero(now.getSeconds())}`;
    }

    function addEvent(obj, evt, fn) {
        if (obj.addEventListener) {
            obj.addEventListener(evt, fn, false);
        }
        else if (obj.attachEvent) {
            obj.attachEvent("on" + evt, fn);
        }
    }

    if (loadMoreTags) {
        loadMoreTags.addEventListener('click', (el) => {
            if(tags) {
                if(tags.classList.contains('expanded')) {
                    tags.classList.remove('expanded');
                    el.target.innerText = 'Pokaż więcej';
                } else {
                    tags.classList.add('expanded');
                    el.target.innerText = 'Pokaż mniej';
                }
            }
        });
    }

    if(commentForm) {
        commentForm.removeAttribute('novalidate');
    }

    if(cookieWrapper) {
        let timer = 5;
        let leaveEvent = false;
        let cookieDays = 0;
        let popupClicked = false;
        let cookieSetClose = false;

        if(cookieWrapper.dataset.timer) {
            timer = Number(cookieWrapper.dataset.timer);
        }
        if(cookieWrapper.dataset.leaveEvent) {
            leaveEvent = true;
        }
        if(cookieWrapper.dataset.cookieTime) {
            cookieDays = Number(cookieWrapper.dataset.cookieTime);
        }
        if(cookieWrapper.dataset.closeCookie) {
            cookieSetClose = true;
        }

        if(leaveEvent === false) {
            setTimeout(() => {
                if (!popupClicked) {
                    cookieWrapper.classList.add('active');
                }
            }, timer * 1000);
        } else if(leaveEvent === true) {
            setTimeout(() => {
                addEvent(document, "mouseout", function(e) {
                    e = e ? e : window.event;
                    var from = e.relatedTarget || e.toElement;
                    if (!from || from.nodeName == "HTML") {
                        if (!popupClicked) {
                            cookieWrapper.classList.add('active');
                        }
                    }
                });
            }, timer * 1000);
        }
        cookieWrapper.addEventListener('click', function(el) {
            if(el.target.classList.contains('exit-popup') || el.target.classList.contains('exit-popup__close')) {
                cookieWrapper.classList.remove('active');
                popupClicked = true;
                if(cookieSetClose && cookieDays > 0) {
                    setCookie('exit-popup',1,cookieDays);
                }
            }
        })
        if(popupForm) {
            popupForm.addEventListener( 'wpcf7mailsent', function( event ) {
                const postTitle = document.getElementsByClassName('hidden-post-title')[0];
                const postUrl = document.getElementsByClassName('hidden-post-url')[0];
                let email = event.detail.inputs.filter(function(item){
                    return item.name === 'your-email';
                })[0].value;

                setTimeout(() => {
                    cookieWrapper.classList.remove('active');
                    popupClicked = true;
                    if(cookieDays > 0) {
                        setCookie('exit-popup',1,cookieDays);
                    }
                    const data = {
                        action: 'add_acf_row',
                        data: getFormattedDate(),
                        adres_email: email,
                        adres_url_strony: (postUrl ? postUrl.value : ''),
                        nazwa_strony: (postTitle ? postTitle.value : '')
                    };

                
                    // Wysłanie żądania AJAX
                    fetch(myScript.ajaxurl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: new URLSearchParams(data).toString()
                    })
                    .then(response => response.json())
                    .then(data => {
                        if(data.success) {
                            console.log('Row added successfully');
                        } else {
                            console.log('Failed to add row');
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
                }, 2000);
            }, false );
        }
    }

    if (navbarMain) {
        window.onscroll = function () {
            if (window.scrollY >= 100) {
                navbarMain.classList.add('opaque');
            } else {
                navbarMain.classList.remove('opaque');
            }
        }
    }

})